import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import t from '../../lib/I18n';

const OrBar = ({ className, horizontal, tablet }) => {
    return (
        <div className={ classnames('or-bar',
            {
                'or-bar--tablet': tablet,
                'or-bar--horizontal': horizontal
            }, className) }>
            <span className="or-bar__bar"/>
            <span className="or-bar__text">{ t('orBar.or') }</span>
            <span className="or-bar__bar"/>
        </div>
    );
};

OrBar.propTypes = {
    className: PropTypes.string,
    horizontal: PropTypes.bool,
    tablet: PropTypes.bool
};

OrBar.defaultProps = {
    className: '',
    horizontal: false,
    tablet: false
};

export default OrBar;



// WEBPACK FOOTER //
// ./src/components/general/OrBar.js